import React from 'react';
import { Box, Container } from '@mui/material';
import { styled } from '@mui/material/styles';
import {
  HeaderSectionSkeleton,
  HeroImgSectionSkeleton,
  PlanSectionSkeleton,
  WhyChooseSubscriptionSectionSkeleton,
} from 'views/membership-module/MembershipView/components';
import {
  MotorcycleRentalsSkeleton,
  MembershipFAQSkeleton,
  MapWithGroupsSkeleton,
} from 'views/common/components';
import { HowItWorksSectionSkeleton } from 'views/membership-module/MembershipLandingView/components';

const StyledBox = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.secondary.dark,
  color: theme.palette.common.fogWhite,
  paddingBottom: theme.spacing(8),
  '& .RTVContainer': {
    padding: theme.spacing(0),
    [theme.breakpoints.down('xxl')]: {
      padding: theme.spacing(0, 6),
    },
    [theme.breakpoints.down('xl')]: {
      padding: theme.spacing(0, 3),
    },
    [theme.breakpoints.down('md')]: {
      padding: theme.spacing(0, 2),
    },
  },
}));

const MembershipViewSkeleton = () => (
  <StyledBox>
    <Container maxWidth="xl" className="RTVContainer">
      <HeroImgSectionSkeleton />
      <HeaderSectionSkeleton />
      <Box mt={3} mb={12}>
        <MotorcycleRentalsSkeleton />
      </Box>
      <Box mb={8}>
        <HeaderSectionSkeleton />
      </Box>
      <Box mb={12}>
        <WhyChooseSubscriptionSectionSkeleton />
      </Box>
      <Box mb={12}>
        <PlanSectionSkeleton />
      </Box>
      <Box mb={12}>
        <HowItWorksSectionSkeleton />
      </Box>
      <Box mb={12}>
        <MembershipFAQSkeleton />
      </Box>
      <Box mb={12}>
        <MapWithGroupsSkeleton />
      </Box>
    </Container>
  </StyledBox>
);
export { MembershipViewSkeleton };
